import { createConsentApi } from './api/index.js';

export function setupTcfApi(window, config) {
    window._tcf_ = createConsentApi(window, config);
}
